import { InputWithLabel } from '@adotel/components'
import SearchIcon from '@material-ui/icons/Search'

import { getTranslate } from '../../localization'
import useStyles from './styles/TemplatesFilters.styles'

interface ProviderFiltersProps {
  inputValue: string | undefined
  setinputVal: (val: string) => void
  loadingForDisableSearchBox: boolean
}

const ProviderFilters: React.FC<ProviderFiltersProps> = ({
  inputValue,
  setinputVal,
  loadingForDisableSearchBox
}) => {
  const classes = useStyles()
  return (
    <div className={[classes.root].join(' ')}>
      <InputWithLabel
        placeholder={getTranslate('Search in provider name or code')}
        autoComplete="off"
        noHelperText
        fullWidth
        startIcon={<SearchIcon />}
        value={inputValue}
        onChange={(event) => setinputVal(event.currentTarget.value)}
        disabled={loadingForDisableSearchBox}
      />
    </div>
  )
}

export default ProviderFilters
